import React from "react";
import { Layout as AntdLayout, Menu, Row, Col } from "antd";
import styled from "@emotion/styled";
import { MenuOutlined } from "@ant-design/icons";
import logokikaholland from "../assets/logokikaholland.png";
import gb from "../assets/gb.png";
import srb from "../assets/srb.png";

const CustomHeader = styled(AntdLayout.Header)({
  textAlign: "left",
  paddingBottom: "5.5%",
  fontcolor: "lightblack",
  backgroundColor: "lightyellow",
  paddingTop: "1%",
  "@media (max-width: 992px)": {
    paddingLeft: "20px",
    paddingRight: "20px",
  },
  "@media (max-width: 768px)": {
    paddingLeft: "20px",
    paddingRight: "20px",
  },
  "@media (max-width: 576px)": {
    paddingLeft: "20px",
    paddingRight: "20px",
  },
  "@media (max-width: 480px)": {
    paddingLeft: "13%",
    paddingRight: "13%",
  },
  "@media (max-width: 380px)": {
    paddingLeft: "11%",
    paddingRight: "11%",
  },
  "@media (max-width: 320px)": {
    paddingLeft: "6%",
    paddingRight: "6%",
  },
});

const HeaderEn: React.FC = (): JSX.Element => (
  <CustomHeader>
    <Row>
      <Col span={24}>
        <Menu
          style={{ backgroundColor: "lightyellow" }}
          theme="light"
          mode="horizontal"
          overflowedIndicator={<MenuOutlined />}
        >
          <Menu.Item className="logokika" key="1">
            <a href="/Home_en">
              <img
                src={logokikaholland}
                className="logokikaholland"
                alt="logo"
                style={{ width: "160px", paddingBottom: "5%" }}
              />
            </a>
          </Menu.Item>
          <Menu.Item className="customclass" key="2">
            <a href="/Home_en">About Us</a>
          </Menu.Item>
          <Menu.Item className="customclass" key="3">
            <a href="/FruitCalendar_en">Fruit Calendar</a>
          </Menu.Item>
          <Menu.Item className="customclass" key="4">
            <a href="/Export_en">Gallery</a>
          </Menu.Item>
          <Menu.Item className="customclass" key="5">
            <a href="/Contact_en">Contact</a>
          </Menu.Item>
          <Menu.Item className="customclass">
            <a href="/">
              <img
                src={srb}
                className="App-logo"
                alt="logo"
                style={{ width: "30px", paddingBottom: "5%" }}
              />
            </a>
          </Menu.Item>
          <Menu.Item className="customclass">
            <a href="/Home_en">
              <img
                src={gb}
                className="App-logo"
                alt="logo"
                style={{ width: "30px", paddingBottom: "5%" }}
              />
            </a>
          </Menu.Item>
        </Menu>
      </Col>
    </Row>
  </CustomHeader>
);

export default HeaderEn;
